
import { DomainRegistry } from "@/domain";
import { Folder } from "@/domain/folder";
import { Component, Mixins } from "vue-property-decorator";

@Component
export default class FolderListMixin extends Mixins() {
  data(): any {
    return {
      isLoading: false,
    };
  }
  isLoading: boolean;

  async getFolderList(): Promise<Folder[]> {
    try {
      this.isLoading = true;
      const repository = DomainRegistry.folder.getFolderRepository();
      return await repository.getFolders();
    } catch (e) {
      this.$error("フォルダ一覧取得エラー", "フォルダ一覧の取得中にエラーが発生しました。", e);
    } finally {
      this.isLoading = false;
    }
  }

  async getFolderInfo(folderGuid: string): Promise<Folder> {
    try {
      const repository = DomainRegistry.folder.getFolderRepository();
      return await repository.getFolder(folderGuid);
    } catch (e) {
      this.$error("フォルダ情報取得エラー", "フォルダ情報の取得中にエラーが発生しました。", e);
      return null;
    }
  }

  async createFolder(folder: Folder): Promise<void> {
    try {
      this.isLoading = true;
      const repository = DomainRegistry.folder.getFolderRepository();
      await repository.createFolder(folder);
    } catch (e) {
      this.$error("フォルダ追加エラー", "フォルダ追加中にエラーが発生しました。", e);
      this.isLoading = false;
    }
  }

  async updateFolder(folder: Folder): Promise<void> {
    try {
      this.isLoading = true;
      const repository = DomainRegistry.folder.getFolderRepository();
      await repository.updateFolder(folder.guid, folder);
    } catch (e) {
      this.$error("フォルダ編集エラー", "フォルダ編集中にエラーが発生しました。", e);
      this.isLoading = false;
    }
  }

  async deleteFolder(folderGuid: string): Promise<void> {
    try {
      this.isLoading = true;
      const repository = DomainRegistry.folder.getFolderRepository();
      await repository.deleteFolder(folderGuid);
    } catch (e) {
      this.$error("フォルダ削除エラー", "フォルダ削除中にエラーが発生しました。", e);
      this.isLoading = false;
    }
  }
}
